import React from "react";
import "./WhatsAppButton.css";

const WhatsAppButton = () => {
  const phoneNumber = "+2349131573928";
  const message = "Hello! I would like to make an inquiry.";

  const handleWhatsAppClick = () => {
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <div className="whatsapp-button" onClick={handleWhatsAppClick}>
      <i className="fa fa-whatsapp"></i>
    </div>
  );
};

export default WhatsAppButton;
